export default __webpack_public_path__ + "static/media/useradd-1.c8e0e154.svg";